import { styled } from "@mui/material/styles";

export const AppWrapper = styled("div")(({ theme }) => ({
  // "& div:nth-of-type(1)": {
  //   backgroundColor: theme.palette.primary.black,
  // },
}));
